import {
    faTrophy,
    faGift,
    faShareAlt
} from '@fortawesome/free-solid-svg-icons';
import { faGem } from '@fortawesome/free-regular-svg-icons';
import { HStack } from 'native-base';
import { Caption } from './Typography';
import React, { ReactNode } from 'react';
import { useTheme } from '@springbig/shared';
import { PageHeaderConfig } from '@springbig/shared/src/settings/defaults';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from './Icon';
import { useLocation } from 'react-router';
import { Button, Panel } from '~/shared/Theme';

export type PageHeaderProps = {
    children?: ReactNode;
    config: PageHeaderConfig;
};

const PageHeader = ({ config, children }: PageHeaderProps) => {

    const location = useLocation();
    const currentPath = location.pathname;
    const name = currentPath.split('/').slice(3).join('/');

    const {
        primary,
    } = useTheme();

    const headerData: Record<string, IconDefinition> = {
        'milestones': faTrophy,
        'offers': faGift,
        'refer': faShareAlt,
        'subscriptions': faGem,
    };

    return (
        <Panel
            row
            justifyContent={'space-between'}
            alignItems={'center'}
            space={4}
        >
            { config.showBackButton &&
                <Button modifier="unlocked" background={'transparent'} borderColor={'transparent'} onPress={() => window.history.back() }>
                    <HStack alignItems='center' space={2}>
                        <FontAwesomeIcon
                            color={primary}
                            icon={faAngleLeft}
                        />
                        <Caption text='general.back' />
                    </HStack>
                </Button>
            }
            <HStack alignItems={'center'} space={2}>
                <Caption
                    text={config.title}
                />
                { headerData[name]?.icon &&
                    <SpIcon
                        color={primary}
                        icon={headerData[name]}
                    />
                }
            </HStack>
            { children }
        </Panel>
    );
};

export default PageHeader;
